import formatNumber from "./formatNumber";

/**
 * [formatPnl withColor Formats text with positive symbol along with color]
 * @param  {Number} num
 *
 * @return {Element}
 */
export default Object.freeze({
  withColor: (data) => (
    <span
      className={`${
        data > 0 ? "profit-text" : data < 0 ? "loss-text" : "neutral-text"
      }`}
    >
      {data > 0 ? "+" : ""}
      {formatNumber(data)}
    </span>
  ),
  withoutColor: (data) => (
    <span>
      {" "}
      {data > 0 ? "+" : ""}
      {formatNumber(data)}
    </span>
  ),
});
